import { Link } from 'react-router-dom';
import { Phone, MessageSquare } from 'lucide-react';

export default function CrisisPage() {
  return (
    <div className="min-h-screen bg-[#F9F8F6] p-6" data-testid="crisis-page">
      <div className="max-w-md mx-auto space-y-6">
        <Link to="/app" className="text-sm text-navy/60">← Back</Link>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-red-700 font-semibold">Crisis Resources</p>
          <h1 className="font-heading text-4xl mt-1">You are not alone.</h1>
          <p className="text-navy/70 mt-2">Reaching out is the strong move. These lines are free, confidential, and available 24/7.</p>
        </div>
        <a href="tel:988" data-testid="crisis-page-988" className="block bg-navy text-white rounded-3xl p-8 card-soft">
          <div className="flex items-center gap-3"><Phone size={20}/><p className="font-heading text-2xl">988</p></div>
          <p className="text-white/70 mt-2 text-sm">Call or text — Suicide & Crisis Lifeline</p>
        </a>
        <a href="sms:741741&body=HOME" data-testid="crisis-page-text" className="block bg-beige rounded-3xl p-8 card-soft">
          <div className="flex items-center gap-3 text-navy"><MessageSquare size={20}/><p className="font-heading text-2xl">741741</p></div>
          <p className="text-navy/70 mt-2 text-sm">Text HOME to 741741 — Crisis Text Line</p>
        </a>
        <a href="tel:911" data-testid="crisis-page-911" className="block bg-white border border-red-200 rounded-3xl p-8 card-soft text-red-700">
          <div className="flex items-center gap-3"><Phone size={20}/><p className="font-heading text-2xl">911</p></div>
          <p className="mt-2 text-sm">If you are in immediate danger.</p>
        </a>
        <p className="text-xs text-navy/50 text-center pt-4">Brotherhood+ is not therapy. If you need a therapist, use our directory. If you&apos;re in crisis, please use the lines above right now.</p>
      </div>
    </div>
  );
}
